module.exports = __webpack_public_path__ + "static/media/full.91e8999c.svg";